import cn from "classnames";
import { Tooltip } from "react-tooltip";

import { setColorStatus, getRequiredRefs } from "../helpers";
import { helperFunctions } from "utilities/helper-functions";

const MarketDataItem = ({
  title,
  onMarketStatusChange,
  requestedMarketsData,
  changingStatus,
  primaryEntitlements,
  entitlements,
  marketItems,
  marketdataProviders,
}) => {
  const renderMarkets = () => {
    return marketItems
      ?.filter((m) => m.group === title)
      .map((item) => {
        const selectedMarkets = entitlements || [];
        const isIncludedBySelectedParent = selectedMarkets.some((selected) =>
          (marketItems?.find((m) => m.name === selected)?.consistsOf || []).includes(
            item.reference
          )
        );
        const isRequiredBySelectedDependency = selectedMarkets.some((selected) =>
          (
            marketItems?.find((m) => m.name === selected)?.dependencyRefs || []
          ).includes(item.reference)
        );
        const isMutuallyExcluded = selectedMarkets.some((selected) => {
          const selectedItem = marketItems?.find((m) => m.name === selected);
          return (
            (selectedItem?.mutuallyExclusive || []).includes(item.reference) ||
            (item.mutuallyExclusive || []).includes(selectedItem?.reference)
          );
        });
        const isDisabled =
          isIncludedBySelectedParent ||
          isRequiredBySelectedDependency ||
          (isMutuallyExcluded && !entitlements?.includes(item.name));

        const onCheckboxHandler = () => {
          if (isDisabled) return;
          onMarketStatusChange(
            item.name,
            !entitlements?.includes(item.name),
            item.reference,
            item.dependencyRefs,
            item.consistsOf,
            item.mutuallyExclusive
          );
        };

        const requiredRefs = (arrayOfRefsToFind) =>
          getRequiredRefs(arrayOfRefsToFind, marketdataProviders)?.map(
            (name) => <span key={name}>{name}</span>
          );

        return (
          <div
            className={cn("market-item", {
              "added-item":
                !primaryEntitlements?.includes(item.name) &&
                entitlements?.includes(item.name),
              "removed-item":
                primaryEntitlements?.includes(item.name) &&
                !entitlements?.includes(item.name),
              disabled: isDisabled,
              // disabled:
              //   !changingStatus &&
              //   requestedMarketsData.status !==
              //     RequestFormStatusTypes.COMPLETED,
            })}
            key={item.name}
          >
            <input
              checked={entitlements?.includes(item.name) || false}
              disabled={isDisabled}
              type="checkbox"
              name={item.name}
              onChange={onCheckboxHandler}
            />
            <span
              onClick={onCheckboxHandler}
              className={`market-checkmark ${setColorStatus({
                name: item.name,
                primaryEntitlements,
                entitlements,
              })}`}
            ></span>
            <span>{item.name}</span>
            {!!item.dependencyRefs?.length && (
              <span className="market-item-dep-ref-info">
                <img
                  id={`anchor-tooltip-${item._id}`}
                  src={`${process.env.PUBLIC_URL}/icons/info.svg`}
                  alt="info"
                />
                <Tooltip
                  delayShow={250}
                  delayHide={400}
                  anchorSelect={`#anchor-tooltip-${item._id}`}
                >
                  <div className="i-text">
                    Requires {requiredRefs(item.dependencyRefs)}
                  </div>
                </Tooltip>
              </span>
            )}
            <span>
              &nbsp;{helperFunctions.currencyFormatter().format(item.price)}
            </span>
          </div>
        );
      });
  };

  if (marketItems?.some((m) => m.group === title))
    return (
      <div className="marketdata-item-block">
        <div className="market-title">{title}</div>
        <div className="market-body">{renderMarkets()}</div>
      </div>
    );

  return null;
};

export default MarketDataItem;
